import React from 'react';
import { TableCell, TableHead, TableRow } from '@mui/material';

const headerCellStyle = {
  fontWeight: 'bold',
  backgroundColor: 'primary.main',
  color: 'primary.contrastText',
};

const emptyHeaderCellStyle = {
  backgroundColor: 'primary.main',
};

// Reusable table header for both Found and Not Found Products tables
export const ProductsTableHeader = ({ type = 'found' }) => {
  // Define headers based on type
  const headers = type === 'found' 
    ? [
        'SKU',
        'Reported By',
        'Rank',
        'Created Time',
        'Main Image',
        'Search Image',
        '', // For tick button
        '', // For cross button
      ]
    : [
        'Reported By',
        'Created Time',
        'Search Image',
      ];

  return (
    <TableHead>
      <TableRow>
        {headers.map((header, index) => (
          <TableCell
            key={header || `empty-${index}`}
            sx={header ? headerCellStyle : emptyHeaderCellStyle}
          >
            {header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
